import { FC, useContext } from "react";
import { useNavigate } from "react-router-dom";

import ContactAndSafetyInfo from "../contactAndSafetyInfo";
import { TextAlignProps } from "../contactAndSafetyInfo/types";
import { AuthContext } from "src/context/authContext";
import { HCPUserSubHeaderProps } from "../../types/users";



const AuthSubHeader: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const { isManufacturer, sub_header } = useContext(AuthContext);

  return (
    <div className="row pt-4 mb-3">
      <div className="col-12 col-lg-6 col-xl-4 text-left mb-2 mb-xl-0">
        {!isManufacturer && (
          <>
            {/* <p className="mb-0 fw-bold">
              KAM Rep: {sub_header ? (sub_header as HCPUserSubHeaderProps).kam_name : ''}
            </p>
            <p className="mb-0 fw-bold">
             KAM Email:
              {sub_header ? (
                <a
                  href={`mailto:${(sub_header as HCPUserSubHeaderProps).kam_email}`}
                >
                  {(sub_header as HCPUserSubHeaderProps).kam_email}
                </a>
              ) : ""}
            </p>
            <p className="mb-0 fw-bold">
              TBM Rep: {sub_header ? (sub_header as HCPUserSubHeaderProps).tbm_name : ''}
            </p>
            <p className="mb-0 fw-bold">
             TBM Email:
              {sub_header ? (
                <a
                  href={`mailto:${(sub_header as HCPUserSubHeaderProps).tbm_email}`}
                >
                  {(sub_header as HCPUserSubHeaderProps).tbm_email}
                </a>
              ) : ""}
            </p> */}
            
              <p className="mb-0 fw-bold d-flex">
                <span className="me-1" style={{minWidth:'92px'}}>KAM Rep:</span>
                <span>{sub_header ? (sub_header as HCPUserSubHeaderProps).kam_name : ''}</span>
              </p>

              <p className="mb-0 fw-bold d-flex flex-wrap">
                <span className="me-1" style={{minWidth:'92px'}}>KAM Email:</span>
                {sub_header ? (
                  <a href={`mailto:${(sub_header as HCPUserSubHeaderProps).kam_email}`}>
                    {(sub_header as HCPUserSubHeaderProps).kam_email}
                  </a>
                ) : (
                  ""
                )}
              </p>

              <p className="mb-0 fw-bold d-flex">
                <span className="me-1" style={{minWidth:'92px'}}>TBM Rep:</span>
                <span>{sub_header ? (sub_header as HCPUserSubHeaderProps).tbm_name : ''}</span>
              </p>

              <p className="mb-0 fw-bold d-flex flex-wrap">
                <span className="me-1" style={{minWidth:'92px'}}>TBM Email:</span>
                {sub_header ? (
                  <a href={`mailto:${(sub_header as HCPUserSubHeaderProps).tbm_email}`}>
                    {(sub_header as HCPUserSubHeaderProps).tbm_email}
                  </a>
                ) : (
                  ""
                )}
              </p>
            
          </>
        )}
      </div>

      <div className="col-12 col-lg-6 col-xl-3 text-center text-lg-end text-xl-center">
        {!isManufacturer && (
          <button className="btn btn-primary mb-2 mb-lg-0 text-nowrap px-5" onClick={() => navigate(`/rep_visits/new`)}>
            <i className="bi-calendar-week-fill pe-1 text-light" style={{ color: 'white' }}></i> Schedule a Rep
            Visit
          </button>
        )}
      </div>
      <div className="col-12 col-lg-12 col-xl-5">
        <ContactAndSafetyInfo textColor="black" alignText={TextAlignProps.TEXT_END} />
      </div>
    </div>
  );
};

export default AuthSubHeader;
